<template>
  <div class="app-container">
    <list ref="list">
        
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="80">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canRead()" type="text" @click="detail(row)">查看</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/clothmanagement/historicalcloth/list'

export default {
  name: "historicalcloth",
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      clothProductionApi: require("@/api/production/clothProduction").default,
    }
  },
  methods: {
    detail(row){
      var loading = this.$loading({
          lock: true,
          text: "正在查询...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        let orderProductId = row.OrderProductId
        this.clothProductionApi.getInfo(orderProductId).then(res => {
          loading.close();
          if(res.Code === 0){
            this.$router.push({
              name: 'editcloth',
              params: {
                data: row,
                resData: res.Data
              }
            })
          }else{
            this.$message({type: 'warning', message: res.Msg})

          }
        }).catch(e => {
          loading.close();
        })
    }
  }
  
};
</script>